export default __webpack_public_path__ + "static/media/speciality.b2d98c1d.jpg";